import React from "react";
import { Row, Col, Image } from "react-bootstrap";
import picky from "./images/projects/picky.png";
import voicify from "./images/projects/voicify.png";
import testing from "./images/projects/testing.png";
import covid from "./images/projects/covid.png";
import CardItem from "./components/Card";
import work_icon from "./images/icons/work_icon.png";
import {
  sectionHeadingStyle,
  headingContainerStyle,
  bioStyle,
} from "./components/styles";

const projectsData = [
  {
    title: "Picky",
    subtitle: "Mobile Social Apps",
    description:
      "Save your time on decision making and have some fun! Whether it be choosing photos to upload on social media or your OOTD, Picky is here to help. Download now to be a part of our fun-loving community.",
    image: picky,
    link: "https://picky.social/",
  },
  {
    title: "Voicify",
    subtitle: "Research Project",
    description:
      "Using a novel deep learning command parser, Voicify interprets human verbal input and performs matching with UI elements. The tool can directly open a specific feature from installed applications by fetching application code information to explore the set of in-app components.",
    image: voicify,
    link: "https://dl.acm.org/doi/abs/10.1145/3581998",
  },
  {
    title: "Accessibility Testing Tool",
    subtitle: "Research Project",
    description:
      "An automated Android testing tool integrated with multiple modules to report usability and accessibility issues. The main objective is to automatically detect issues of given APKs on multiple devices with various device settings.",
    image: testing,
    link: "https://github.com/vuminhduc796/AccessibilityTool",
  },
  {
    title: "COVID-19 Visualisation Dashboard",
    subtitle: "Web dev & Visualisations",
    description:
      "A self-hosted web page that displays COVID-19 data for different countries in the world using D3 and Vegalite. It was submitted as an assignment at Monash University.",
    image: covid,
    link: "https://github.com/vuminhduc796/FIT3179-Assignment2",
  },
];

const ProjectSection = () => {
  return (
    <div style={sectionContainerStyle}>
      <div style={headingContainerStyle}>
        <h2 style={sectionHeadingStyle}>Projects</h2>
        <Image
          src={work_icon}
          alt=""
          className="section-icon"
        />
      </div>

      <p style={bioStyle}>
        A few public projects across mobile, accessibility, research tooling,
        and data visualisation. Each one taught me something practical about
        shipping software beyond the tutorial stage.
      </p>

      <Row className="g-4" style={projectGridStyle}>
        {projectsData.map((project) => (
          <Col key={project.title} xs={12} md={6} xl={3}>
            <CardItem obj={project} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

const sectionContainerStyle = {
  minHeight: "100vh",
  width: "100%",
  padding: "clamp(88px, 8vw, 128px) clamp(20px, 7vw, 104px)",
  backgroundColor: "transparent",
  textAlign: "left",
};

const projectGridStyle = {
  marginTop: "30px",
};

export default ProjectSection;
